import type { BoolFilter } from '@sbt-web/network/types';
import { FormGroup, FormLabel, Toggle } from '@sbt-web/ui';
import React from 'react';

import commonClasses from '../SelectorStyles/common.module.scss';

interface BSProps {
  filter: BoolFilter;
  initialValue?: string;
  onSelect: (key: string, value?: string, label?: string) => void;
}

export const BoolSelector: React.FunctionComponent<BSProps> = (props) => {
  const { filter, initialValue, onSelect } = props;

  const handleSelection = (selected: boolean) => {
    return onSelect(
      filter.queryString,
      selected ? 'true' : undefined,
      selected ? filter.label : undefined
    );
  };

  return (
    <FormGroup>
      <div className={commonClasses['filler-div']}>
        <FormLabel>{filter.label}</FormLabel>
      </div>

      <Toggle
        name={filter.uri}
        checked={initialValue != undefined}
        onInputChange={handleSelection}
        spaceBetweenElements
        classes={[commonClasses['custom-toggle']]}
      >
        {filter.subLabel ?? filter.label}
      </Toggle>
    </FormGroup>
  );
};
